import React from "react";
import styles from "../../components/signupastutor/style/tutorapp.module.css";
import tutimg1 from "../../../assets/tutorpages/tut1.png";
import tutimg2 from "../../../assets/tutorpages/tut2.png";
import tutimg3 from "../../../assets/tutorpages/tut3.png";

const Tutorapp = () => {
  return (
    <div className={styles.container}>
      <h1 style={{ color: "#7F60F9" }}>
        <b>How our tutorapp works:</b>
      </h1>
      <div className={styles.tutorList}>
        {/* Tutor details with images */}
        <div className={styles.tutorDetails}>
          <h2>
            <b>Find Tutors.</b>
          </h2>
          <p>
            We'll connect you with a tutor who will motivate, challenge, and
            inspire you.
          </p>
          <img src={tutimg1} alt="Find Tutors" className={styles.tutorImage} />
        </div>
        <div className={styles.tutorDetails}>
          <h2>
            <b>Start learning.</b>
          </h2>
          <p>
            Your tutor will guide the way through your first lesson and help you
            plan your next steps.
          </p>
          <img
            src={tutimg2}
            alt="Start Learning"
            className={styles.tutorImage}
          />
        </div>
        <div className={styles.tutorDetails}>
          <h2>
            <b>Speak. Read. Write. Repeat.</b>
          </h2>
          <p>
            Choose how many lessons you want to take each week and get ready to
            reach your goals.
          </p>
          <img
            src={tutimg3}
            alt="Speak, Read, Write, Repeat"
            className={styles.tutorImage}
          />
        </div>
      </div>
      {/* Button section */}
      {/* <div className={styles.buttonContainer}>
                <button type="submit" className={styles.chatButton}>Chat Now</button>
            </div> */}
    </div>
  );
};

export default Tutorapp;
